export default "__VITE_ASSET__c4765a88__$_?react__"